module.exports = __webpack_public_path__ + "img/nir_logo.cb1b4269.png";